import { render } from "./RibaReport.vue?vue&type=template&id=4f336693"
import script from "./RibaReport.vue?vue&type=script&lang=js"
export * from "./RibaReport.vue?vue&type=script&lang=js"
script.render = render

export default script